(function($) {


    let scrolling = false;

    let phone_num_wrapper = $('#phone-num-wrapper');
    let loadingCss = false, cssLoaded = false;

    function doScrolling() {

        if (!loadingCss && window.isInViewport(phone_num_wrapper)) {

            loadingCss = true;
            !cssLoaded && import(/* webpackChunkName: "contact" */'./contact')
                .then(module => {
                    loadingCss = false;
                    cssLoaded = true;
                    //module.default();
                });
        }

    }


    window.scrollingTasks.push(doScrolling);



})($);


